// extracted by mini-css-extract-plugin
export default {"external":"agNkCp","deprecatedBorderRadius":"bgNkCp","hasAnimation":"cgNkCp","container":"dgNkCp"};